import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import OgloszeniaList from "@/components/OgloszeniaList";
import api from "@/lib/api";
import useSeo from "@/hooks/useSeo";

export default function OgloszeniaPage() {
    const [cat, setCat] = useState("all");
    const [labels, setLabels] = useState({});
    const [categories, setCategories] = useState([]);

    useSeo({
        title: "Ogłoszenia mieszkańców",
        description: "Sprzedaż, wymiana, usługi i drobne ogłoszenia mieszkańców Dąbrówki Wiślanej – Aluzyjna 25 C/D/E/F.",
    });

    useEffect(() => {
        document.title = "Ogłoszenia mieszkańców – Dąbrówka Wiślana";
        api.get("/listings/categories").then((r) => {
            setLabels(r.data?.labels || {});
            setCategories(r.data?.categories || []);
        }).catch(() => {});
    }, []);

    return (
        <div className="min-h-screen bg-[#FAF8F3]" data-testid="ogloszenia-page">
            <Navbar />
            <header className="bg-[#092E22] text-white pt-32 pb-14">
                <div className="max-w-6xl mx-auto px-6 lg:px-10">
                    <Link to="/" className="text-[#D4A537] text-sm hover:underline">← Powrót na stronę główną</Link>
                    <h1 className="font-serif text-4xl md:text-5xl mt-4 flex items-center gap-3">
                        <Megaphone className="text-[#D4A537]" /> Ogłoszenia mieszkańców
                    </h1>
                    <p className="text-white/70 mt-3 max-w-2xl">
                        Sprzedaj, kup, zamień lub oddaj coś sąsiadom albo dodaj drobne ogłoszenie. Wszystkie zgłoszenia są moderowane,
                        a po 30 dniach automatycznie archiwizowane.
                    </p>
                </div>
            </header>

            <main className="max-w-6xl mx-auto px-6 lg:px-10 py-12">
                <div className="flex flex-wrap gap-2 mb-8" data-testid="ogloszenia-category-filter">
                    <button
                        onClick={() => setCat("all")}
                        data-testid="ogloszenia-cat-all"
                        className={`px-4 py-1.5 rounded-full text-xs font-medium uppercase tracking-wider transition-all ${
                            cat === "all" ? "bg-[#0D4F3C] text-white" : "bg-white text-gray-600 hover:text-[#0D4F3C] border border-gray-200"
                        }`}
                    >
                        Wszystkie
                    </button>
                    {categories.map((k) => (
                        <button
                            key={k}
                            onClick={() => setCat(k)}
                            data-testid={`ogloszenia-cat-${k}`}
                            className={`px-4 py-1.5 rounded-full text-xs font-medium uppercase tracking-wider transition-all ${
                                cat === k ? "bg-[#0D4F3C] text-white" : "bg-white text-gray-600 hover:text-[#0D4F3C] border border-gray-200"
                            }`}
                        >
                            {labels[k] || k}
                        </button>
                    ))}
                </div>

                <OgloszeniaList category={cat === "all" ? null : cat} pageSize={9} />

                <div className="mt-12 text-center">
                    <Link
                        to="/ogloszenia/dodaj"
                        data-testid="ogloszenia-cta-add"
                        className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-[#D4A537] hover:bg-[#B88A26] text-white font-medium"
                    >
                        Dodaj swoje ogłoszenie <ArrowRight size={16} />
                    </Link>
                </div>
            </main>

            <Footer />
        </div>
    );
}
